module.exports = __webpack_public_path__ + "static/WIIBPhone5-d64b646bcecb323c0481a8208592dcb7.svg";